import { PseudoSection } from 'components/main/section-router/pseudo-section';
import { t } from 'i18next';

export const Unavailable = () => (
  <PseudoSection
    header={t('main.unavailable')}
    content={
      <>
        <p>This section is currently unavailable.</p>
        <p>Please try again later.</p>
      </>
    }
  />
);
